import {
  ROOT_ANALYTICS_ENHANCERS,
  AnalyticsEnhancerSources,
} from '@analytics/enhancers';
import type { AnalyticsEnhancer } from '@analytics/models';
import { CommonModule } from '@angular/common';
import { inject, Inject, NgModule, Optional } from '@angular/core';

@NgModule({
  imports: [CommonModule],
})
export class AnalyticsRootModule {
  sources = inject(AnalyticsEnhancerSources);

  constructor(
    @Optional()
    @Inject(ROOT_ANALYTICS_ENHANCERS)
    rootEnhancers: AnalyticsEnhancer[]
  ) {
    rootEnhancers?.forEach((enhancerSourceInstance) =>
      this.sources.addEnhancers(enhancerSourceInstance)
    );
  }

  addEnhancers(enhancerSourceInstance: AnalyticsEnhancer) {
    this.sources.addEnhancers(enhancerSourceInstance);
  }
}
